var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wallet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "budicon-wallet"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,7H23V2a1,1,0,0,0-1-1H4.5A3.5,3.5,0,0,0,1,4.5v18A1.5,1.5,0,0,0,2.5,24h21A1.5,1.5,0,0,0,25,22.5V8.5A1.5,1.5,0,0,0,23.5,7ZM5,6A1,1,0,0,1,6,5H22V7H6A1,1,0,0,1,5,6ZM4.5,2H22V4H6A2,2,0,0,0,4,6a1.978,1.978,0,0,0,.264.976A2.493,2.493,0,0,1,4.5,2ZM24,17H20V14h4Zm-4-4a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4v4.5a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V6.944A3.485,3.485,0,0,0,4.5,8h19a.5.5,0,0,1,.5.5V13Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.a2022354fd909f218b6f5ef190575d20.svg";
export { ForwardRef as ReactComponent };